import { useAppHeader } from '@bupa-monorepo/shared-frontend/customer-auth';

export const useCompanyCreationMainPageAppHeader = () => {
  useAppHeader({
    backButton: {
      text: 'Vissza a vállalkozásindításra',
      url: '/vallalkozas-alapitas',
    },
  });
};

export const useSinglePersonStepPageAppHeader = (): void => {
  useAppHeader({
    backButton: {
      text: 'Vissza az egyszemélyes kft. alapításra',
      url: '/vallalkozas-alapitas/egyszemelyes',
    },
  });
};

export const useSelfEmploymentStepPageAppHeader = (): void => {
  useAppHeader({
    backButton: {
      text: 'Vissza az egyénivállalkozás-alapításra',
      url: '/vallalkozas-alapitas/egyeni-vallalkozas',
    },
  });
};
